import { Component, ViewEncapsulation } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import {
  DoenkidsSessionProvider,
  IDoenKidsSession,
} from 'src/providers/session.provider';
import { isNil } from 'lodash';
import { filter, map, tap } from 'rxjs/operators';
import { IMediaItem } from 'typings/section-types';
import { Router } from '@angular/router';
import { ThemeService } from 'src/app/core/services/theme.service';

@Component({
  selector: 'app-profile-panel',
  templateUrl: './profile-panel.component.html',
  styleUrls: ['./profile-panel.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: [],
  standalone: false,
})
export class ProfilePanelComponent {
  public stop$ = new Subject<void>();

  public session$: BehaviorSubject<IDoenKidsSession>;

  // The profile picture
  //
  mediaItem$: Observable<IMediaItem>;

  // The e-mail address of the logged-in user
  //
  emailAddress$;

  avatarPlaceholder$: Observable<string>;

  constructor(public $doenkidsSession: DoenkidsSessionProvider, private router: Router, private themeService: ThemeService) {
    this.avatarPlaceholder$ = this.themeService.currentTheme$.pipe(
      map(theme => theme.assets.avatarImg || './assets/images/avatar-placeholder.png'),
    );

    this.session$ = this.$doenkidsSession.getSession$;

    this.mediaItem$ = this.session$.pipe(
      filter((session) => !isNil(session)),
      map((session: IDoenKidsSession) => {
        const { mediaUuid } = session;
        const mediaItem: IMediaItem = {
          uuid: mediaUuid,
          description: '',
        };
        return mediaItem;
      }),
    );

    this.emailAddress$ = this.session$.pipe(
      filter((session) => !isNil(session)),
      map((session: IDoenKidsSession) => session.emailAddress),
    );
  }

  async navigateToProfile() {
    const organization = this.$doenkidsSession.getCurrentOu();
    const currentUser = this.$doenkidsSession.getCurrentUser();

    this.router.navigate([`/organization/${organization.id}/users/${currentUser.user.id}`]);
  }
}
